exports.onRouteUpdate = () => {
  const body = document.querySelector('body');

  body.classList.remove('no-scroll');
  setTimeout(() => {
    body.scrollTo(0, 0);
  }, 10);
};
